export default __webpack_public_path__ + "static/europe-5534d14efbdfbb385adb1b521b11d4e6.jpg";